import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import './GlobalSearch.css';
import './GlobalSearchPlacement.css';

const SEARCH_API='https://kanban.ehv.ams-crm.fr/api/global_search.php';
const AUTO_LOGIN_API='https://kanban.ehv.ams-crm.fr/api/auto_login.php';

export default function GlobalSearch({apps=[]}){
  const navigate=useNavigate();
  const inputRef=useRef(null);
  const requestRef=useRef(0);
  const [open,setOpen]=useState(false);
  const [query,setQuery]=useState('');
  const [results,setResults]=useState([]);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');
  const allowed=useMemo(()=>new Set(apps.map(app=>app.key)),[apps]);

  useEffect(()=>{
    const onKeyDown=event=>{
      if((event.ctrlKey||event.metaKey)&&event.key.toLowerCase()==='k'){event.preventDefault();setOpen(true);window.setTimeout(()=>inputRef.current?.focus(),20)}
      if(event.key==='Escape')setOpen(false);
    };
    window.addEventListener('keydown',onKeyDown);return()=>window.removeEventListener('keydown',onKeyDown);
  },[]);

  useEffect(()=>{
    if(!open||query.trim().length<2){setResults([]);setError('');setLoading(false);return;}
    const requestId=++requestRef.current;
    const timer=window.setTimeout(async()=>{
      setLoading(true);setError('');
      try{
        const token=localStorage.getItem(config.tokenKey)||'';
        const headers={Authorization:`Bearer ${token}`,Accept:'application/json'};
        const login=await fetch(AUTO_LOGIN_API,{headers,cache:'no-store'});if(!login.ok)throw new Error('Session de recherche expirée.');
        const response=await fetch(`${SEARCH_API}?q=${encodeURIComponent(query.trim())}`,{headers,cache:'no-store'});
        const payload=await response.json().catch(()=>({}));if(!response.ok)throw new Error(payload.error||'Recherche indisponible.');
        if(requestId===requestRef.current)setResults((payload.results||[]).filter(result=>allowed.has(result.app_key)));
      }catch(searchError){if(requestId===requestRef.current){setResults([]);setError(searchError.message)}}
      finally{if(requestId===requestRef.current)setLoading(false)}
    },260);
    return()=>window.clearTimeout(timer);
  },[open,query,allowed]);

  const openResult=result=>{
    const params=new URLSearchParams();
    if(result.project_id)params.set('project_id',result.project_id);
    if(result.task_id)params.set('task_id',result.task_id);
    if(result.form_id)params.set('form_id',result.form_id);
    if(result.document_id)params.set('document_id',result.document_id);
    if(result.user_id)params.set('user_id',result.user_id);
    if(result.search_value)params.set('search',result.search_value);
    navigate(`/${result.app_key}${params.toString()?`?${params}`:''}`);setOpen(false);
  };

  return <>
    <button className="global-search-trigger" type="button" onClick={()=>{setOpen(true);window.setTimeout(()=>inputRef.current?.focus(),20)}} title="Recherche globale (Ctrl K)"><span>⌕</span><b>Recherche globale</b><kbd>Ctrl K</kbd></button>
    {open&&createPortal(<div className="global-search-overlay" onMouseDown={event=>{if(event.target===event.currentTarget)setOpen(false)}}><section className="global-search-dialog" role="dialog" aria-modal="true" aria-label="Recherche globale"><header><span>⌕</span><input ref={inputRef} type="search" value={query} onChange={event=>setQuery(event.target.value)} placeholder="EHV, commune, client, tâche, facture…" autoFocus/><kbd>Échap</kbd></header><div className="global-search-results">{loading&&<p className="global-search-empty">Recherche en cours…</p>}{error&&<p className="global-search-empty error">{error}</p>}{!loading&&!error&&query.trim().length<2&&<p className="global-search-empty">Saisissez au moins deux caractères.</p>}{!loading&&!error&&query.trim().length>=2&&!results.length&&<p className="global-search-empty">Aucun résultat accessible.</p>}{!loading&&results.map((result,index)=><button key={`${result.type}-${result.project_id||result.user_id||index}-${index}`} type="button" className="global-search-result" onClick={()=>openResult(result)}><span className="result-icon">{result.icon}</span><span className="result-copy"><small>{result.type_label}</small><strong>{result.title}</strong><em>{result.subtitle}</em>{result.meta&&<i>{result.meta}</i>}</span><span className="result-open">Ouvrir →</span></button>)}</div><footer><span>{results.length} résultat{results.length>1?'s':''}</span><small>Les droits de votre compte sont appliqués.</small></footer></section></div>,document.body)}
  </>;
}
